import { ExerciseType } from '../../../shared/utils/enums';


declare global {
  interface Window {
    injectedEnv: Record<string, string>;
  }
}

export interface Patient {
  firstName?: string;
  lastName?: string;
  email?: string;
  isMobileRole: boolean;
  accountId: string;
  isEmailVerified: boolean;
}
export interface IChatMessage {
  messageType:string,
  text: string,
  senderId: string,
  ackId?:string,
  isNew:boolean,
  createdAt: string;
}

export interface ITherapist {
  _id?: string;
  // accountId: string;
  // email: string;
  firstName?: string;
  lastName?: string;
  birthDate?: Date;
  postal?: string;
  city?: string;
  street?: string;
  telephone: string;
  about?: string;
  profilePic?: string;
  specialization?: any[]; // Types.Array<ObjectId>; Is this expanded? => | any / | ISpecialization[]
  availability?: IAvailability;
  plans?: string[];
  approved: boolean;
  // referralCode: string;
  // lastLogin: Date;
  isCallAllowed: boolean;
  country: string;
  // isTestUser: boolean;
  // onSchedResourceID?: string;
  bookingBefore?: number;
  notAllowedFeature?: string[];
  // onSchedBlockID?: string[];
  therapistPlan?: string; // ObjectId; Is this expanded? => | any / | ITherapistPlan
}

export interface ITherapy {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  patient?: Patient;
  seniorMode?: boolean;
  pdfPassword?: string;
  patientProfile: boolean;
  shouldSendInviteEmail?: boolean;
  inviteMessage?: string;
  workouts: Array<IWorkoutWeek>;
  proms: Array<IProm>;
  sessions?: Array<any>;
  files?: Array<any>;
  isMobileRole: boolean;
  accountId: string;
}

export interface IPatient {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  id?: string;
  seniorMode?: boolean;
  patientProfile: boolean;
  isMobileRole: boolean;
}

export enum WorkoutStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  DELETED = 'DELETED',
}

export enum PromStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  DELETED = 'DELETED',
}

export enum PromQuestionType {
  RANGE = 'RANGE',
}

export interface IWorkoutSet {
  _id?: string;
  setRepetitions: number;
  completedRepetitions: number;
}

export interface IWorkoutExercise {
  _id?: string;
  title: string;
  mainJoint: string;
  dynamicCondition: boolean;
  breakBetweenSets: number;
  noteTherapist?: string;
  video?: string;
  sets: Array<IWorkoutSet>;
}

export interface IWorkoutUnit {
  _id?: string;
  title: string;
  exercises: Array<IWorkoutExercise>;
}

export interface IWorkoutWeek {
  _id: string;
  therapy: string;
  title: string;
  calendarWeek: number;
  feedbackPatient: string;
  noteTherapist: string;
  imageUrl: string;
  questionnaire: string;
  units: Array<IWorkoutUnit>;
  status: WorkoutStatus;
}

export interface IPromQuestionChoice {
  isSelected: boolean;
  _id?: string;
  title: string;
  value: string;
}

export enum TriggerType {
  Everyday = 'EVERYDAY',
  EveryWeek = 'EVERY_WEEK',
  EverySecondWeek = 'EVERY_SECOND_WEEK',
  BeforeWorkoutWeek = 'BEFORE_WORKOUT_WEEK',
  AfterWorkoutWeek = 'AFTER_WORKOUT_WEEK',
  BeforeExercise = 'BEFORE_EXERCISE',
  AfterExercise = 'AFTER_EXERCISE',
}

export interface IPromTrigger {
  triggerType: TriggerType;
  objectID: string;
}

export interface IPromQuestion {
  rangeValue: number;
  _id?: string;
  type: PromQuestionType;
  title: string;
  choices: Array<IPromQuestionChoice>;
}

export interface IProm {
  status: PromStatus;
  _id?: string;
  template: string;
  title: string;
  questions: Array<IPromQuestion>;
  questionnaireTemplateId: string;
  therapy: string;
  triggers: Array<IPromTrigger>;
}

export interface IDayAvailability {
  startTime: number;
  endTime: number;
}

export interface IAvailability {
  mon: IDayAvailability[];
  tue: IDayAvailability[];
  wed: IDayAvailability[];
  thu: IDayAvailability[];
  fri: IDayAvailability[];
  sat: IDayAvailability[];
  sun: IDayAvailability[];
}

export interface IFile {
  id: string;
  created: Date;
  name: string;
  url?: string;
  user: string;
  session?: string;
  patient?: string;
  deleted?: boolean;
  type?: string;
}

export interface IScheduledSession {
  id: string;
  start: Date;
  end: Date;
  patient: string;
  therapist: string;
}

export interface IErrorDto {
  error: string;
}

export interface IAppointment {
  _id: string;
  active?: boolean;
  duration?: number;
  endDateTime?: Date;
  name?: string;
  patient?: Patient;
  roomCode?: string;
  startDateTime?: Date;
  status?: AppointmentStatus;
  therapist?: ITherapist;
  startTimestamp?: Date;
}

export enum AppointmentStatus {
  REQUESTED = 'requested',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  COMPLETED = 'completed',
  THERAPIST_CANCELLED = 'cancelled_by_therapist',
  PATIENT_CANCELLED = 'cancelled_by_patient',
  REJECTED = 'rejected',
  DELETED = 'deleted',
}

export const exerciseTypeLabels: Record<ExerciseType, string> = {
  static: 'exerciseVideoTypeEnum.static',
  dynamic: 'exerciseVideoTypeEnum.dynamic',
  relaxation: 'exerciseVideoTypeEnum.relaxation',
  endurance: 'exerciseVideoTypeEnum.endurance',
  teaching: 'exerciseVideoTypeEnum.teaching',
};

export type ScopeKey = 'tenant' | 'core';
export type ManagementMode = 'admin' | 'superAdmin';

export function isScopeKey(value: string | null): value is ScopeKey {
  return value === 'tenant' || value === 'core';
}
